import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large",
    attrs: {
      id: "pre-home"
    }
  }, [_c("BackgroundVideo"), _c("div", {
    staticClass: "subscribe-container container-centered small-2"
  }, [_vm.step == 1 || _vm.step == 2 ? _c("div", [_c("div", {
    staticClass: "account-selectors"
  }, _vm._l(_vm.accountTypes, function (accountType) {
    return _c("div", {
      key: accountType.id,
      staticClass: "account-selectors-selector",
      class: [_vm.user_group == accountType.id && "selected"],
      on: {
        click: function click($event) {
          return _vm.selectAccountType(accountType.id, this);
        }
      }
    }, [_c("div", {
      staticClass: "account-selectors-selector-txt"
    }, [_vm._v(" " + _vm._s(accountType.name) + " ")])]);
  }), 0)]) : _vm._e(), _vm.step == 2 ? _c("div", [_c("div", [_c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Email",
      placeholder: "john.doe@domain.com",
      autofocus: ""
    },
    model: {
      value: _vm.input.email,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "email", $$v);
      },
      expression: "input.email"
    }
  }), _vm.errorLabels.email.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.email) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    staticClass: "required white-append-icon",
    attrs: {
      label: "Password",
      type: _vm.isShowPassword ? "text" : "password"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c("span", {
          staticClass: "cursor--pointer",
          on: {
            click: function click($event) {
              _vm.isShowPassword = !_vm.isShowPassword;
            }
          }
        }, [!_vm.isShowPassword ? _c(VIcon, [_vm._v("mdi-eye")]) : _c(VIcon, [_vm._v("mdi-eye-off")])], 1)];
      },
      proxy: true
    }], null, false, 3100851295),
    model: {
      value: _vm.input.password,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "password", $$v);
      },
      expression: "input.password"
    }
  }), _vm.errorLabels.password.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.password) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    staticClass: "required white-append-icon",
    attrs: {
      label: "Re-type your password",
      type: _vm.isShowPassword ? "text" : "password"
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c("span", {
          staticClass: "cursor--pointer",
          on: {
            click: function click($event) {
              _vm.isShowPassword = !_vm.isShowPassword;
            }
          }
        }, [!_vm.isShowPassword ? _c(VIcon, [_vm._v("mdi-eye")]) : _c(VIcon, [_vm._v("mdi-eye-off")])], 1)];
      },
      proxy: true
    }], null, false, 3100851295),
    model: {
      value: _vm.input.passwordconfirm,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "passwordconfirm", $$v);
      },
      expression: "input.passwordconfirm"
    }
  }), _vm.errorLabels.passwordconfirm.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.passwordconfirm) + " ")]) : _vm._e()], 1)]), _vm.user_group === "HORECA" ? _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Company name",
      placeholder: "Your company name"
    },
    model: {
      value: _vm.input.company_name,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "company_name", $$v);
      },
      expression: "input.company_name"
    }
  }), _vm.errorLabels.company_name.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.company_name) + " ")]) : _vm._e()], 1) : _vm._e(), _c("div", [_c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "First name",
      placeholder: "John"
    },
    model: {
      value: _vm.input.name,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "name", $$v);
      },
      expression: "input.name"
    }
  }), _vm.errorLabels.name.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.name) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Last name",
      placeholder: "Doe"
    },
    model: {
      value: _vm.input.nickname,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "nickname", $$v);
      },
      expression: "input.nickname"
    }
  }), _vm.errorLabels.nickname.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.nickname) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Phone number",
      placeholder: "+33686868686"
    },
    model: {
      value: _vm.input.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "phone", $$v);
      },
      expression: "input.phone"
    }
  }), _vm.errorLabels.phone.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.phone) + " ")]) : _vm._e()], 1), _c("div", [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.listCountries,
      "item-text": "printable_name",
      label: "Delivery Country",
      "return-object": "",
      filter: _vm.filterVAutocomplete,
      "no-data-text": _vm.infosMessages.country.notAvailable,
      dark: _vm.$whitelabel.tenantType == _vm.tenantType.OWNER
    },
    on: {
      blur: function blur($event) {
        return _vm.countryNotAvailable();
      },
      change: function change() {
        _vm.input.state = null;
        _vm.countryNotAvailable();
      }
    },
    model: {
      value: _vm.input.country,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "country", $$v);
      },
      expression: "input.country"
    }
  }), _vm.errorLabels.country.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.country) + " ")]) : _vm._e(), _vm.infosLabels.country.length > 0 ? _c("p", {
    staticClass: "infosLabel"
  }, [_vm._v(" " + _vm._s(_vm.infosLabels.country) + " ")]) : _vm._e()], 1), _vm.countryHasStates ? _c("div", [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.getStatesForSelectedCountry(),
      "item-text": "state_label",
      label: "State",
      "return-object": "",
      dark: _vm.$whitelabel.tenantType == _vm.tenantType.OWNER
    },
    model: {
      value: _vm.input.state,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "state", $$v);
      },
      expression: "input.state"
    }
  }), _vm.errorLabels.state.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.state) + " ")]) : _vm._e()], 1) : _vm._e(), _c("div", [_c(VCombobox, {
    staticClass: "required",
    attrs: {
      label: "Road",
      items: _vm.addressSuggestions,
      loading: _vm.loadingAddressSuggestions,
      "search-input": _vm.searchInput,
      placeholder: "1 Faubourg Saint-Honoré",
      clearable: "",
      "item-text": "place_name",
      "no-filter": "",
      dark: _vm.$whitelabel.tenantType == _vm.tenantType.OWNER
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.searchInput = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.searchInput = $event;
      },
      change: _vm.onAddressSelected
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.place_name))])], 1)];
      }
    }, {
      key: "append",
      fn: function fn() {
        return [_c(VIcon, {
          staticClass: "cursor--pointer",
          attrs: {
            disabled: _vm.loadingCurrentLocation
          },
          on: {
            click: _vm.useCurrentLocation
          }
        }, [_vm._v(" " + _vm._s(_vm.loadingCurrentLocation ? "mdi-loading mdi-spin" : "mdi-crosshairs-gps") + " ")])];
      },
      proxy: true
    }], null, false, 3073090437),
    model: {
      value: _vm.input.street,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "street", $$v);
      },
      expression: "input.street"
    }
  }), _vm.errorLabels.street.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.street) + " ")]) : _vm._e()], 1), _c("div", [_vm.input.address_line_2 || _vm.input.street ? _c(VTextField, {
    attrs: {
      label: "Address line 2",
      placeholder: "Apartment 123"
    },
    model: {
      value: _vm.input.address_line_2,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "address_line_2", $$v);
      },
      expression: "input.address_line_2"
    }
  }) : _vm._e()], 1), _c("div", [_vm.input.address_line_3 || _vm.input.address_line_2 ? _c(VTextField, {
    attrs: {
      label: "Address line 3",
      placeholder: "Unit 12"
    },
    model: {
      value: _vm.input.address_line_3,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "address_line_3", $$v);
      },
      expression: "input.address_line_3"
    }
  }) : _vm._e()], 1), _c("div", [_vm.input.address_complement || _vm.input.address_line_3 ? _c(VTextField, {
    attrs: {
      label: "Address complement",
      placeholder: "Last house on the left"
    },
    model: {
      value: _vm.input.address_complement,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "address_complement", $$v);
      },
      expression: "input.address_complement"
    }
  }) : _vm._e()], 1), _c(VTextField, {
    attrs: {
      label: "Zip code",
      placeholder: "75001"
    },
    model: {
      value: _vm.input.zipcode,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "zipcode", $$v);
      },
      expression: "input.zipcode"
    }
  }), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "City",
      placeholder: "Paris"
    },
    model: {
      value: _vm.input.city,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "city", $$v);
      },
      expression: "input.city"
    }
  }), _vm.errorLabels.city.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.city) + " ")]) : _vm._e()], 1), _vm.user_group === "HORECA" ? _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: _vm.taxIdLabel,
      placeholder: _vm.taxIdLabel
    },
    model: {
      value: _vm.input.vat_code,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "vat_code", $$v);
      },
      expression: "input.vat_code"
    }
  }), _vm.errorLabels.vat_code.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.vat_code) + " ")]) : _vm._e()], 1) : _vm._e(), _vm.user_group === "HORECA" ? _c("div", [_c(VTextField, {
    class: !!_vm.input.country && (_vm.input.country.iso_code == "USA" || _vm.input.country.iso_code == "BRA") ? "required" : "",
    attrs: {
      label: _vm.liquorNumberLabel,
      placeholder: _vm.liquorNumberLabel
    },
    model: {
      value: _vm.input.excise_code,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "excise_code", $$v);
      },
      expression: "input.excise_code"
    }
  }), _vm.errorLabels.excise_code.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.excise_code) + " ")]) : _vm._e()], 1) : _vm._e(), _vm.user_group === "USER" ? _c("div", [_c(VTextField, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.input.country && _vm.input.country.iso_code == "BRA",
      expression: "!!input.country && input.country.iso_code == 'BRA'"
    }],
    attrs: {
      label: _vm.individualCodeLabel,
      placeholder: _vm.individualCodeLabel
    },
    model: {
      value: _vm.input.individualCode,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "individualCode", $$v);
      },
      expression: "input.individualCode"
    }
  })], 1) : _vm._e(), _c("div", [_c(VTextField, {
    attrs: {
      label: "Billing email address",
      placeholder: "Your specific billing email address"
    },
    model: {
      value: _vm.input.billingEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "billingEmail", $$v);
      },
      expression: "input.billingEmail"
    }
  }), _vm.errorLabels.billingEmail.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.billingEmail) + " ")]) : _vm._e()], 1)], 1), _vm.$whitelabel.tenantType == _vm.tenantType.OWNER ? _c("div", [_c(VTextField, {
    attrs: {
      label: "Keypass",
      placeholder: "Code received in your invitation"
    },
    model: {
      value: _vm.input.sponsorship_code,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "sponsorship_code", $$v);
      },
      expression: "input.sponsorship_code"
    }
  })], 1) : _vm._e(), _c("div", [_c(VCheckbox, {
    class: _vm.tenant_type == _vm.tenantType.OWNER ? "checkbox-container-light" : "",
    model: {
      value: _vm.input.certify_legal_age,
      callback: function callback($$v) {
        _vm.$set(_vm.input, "certify_legal_age", $$v);
      },
      expression: "input.certify_legal_age"
    }
  }, [_c("div", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v("I certify that I am of legal age to purchase alcohol")])]), _vm.errorLabels.certify_legal_age.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.certify_legal_age) + " ")]) : _vm._e()], 1), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "create-my-account-button",
    on: {
      click: function click($event) {
        return _vm.create();
      }
    },
    nativeOn: {
      shortkey: function shortkey($event) {
        return _vm.create();
      }
    }
  }, [_vm._v(" CREATE MY ACCOUNT ")])], 1)]) : _vm._e(), _vm.step == 3 ? _c("div", [_c("h2", {
    staticClass: "title-margin-b"
  }, [_vm._v("Subscription received")]), _vm._m(0), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --with-dark-bg",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.home();
      }
    }
  }, [_vm._v("Home")])], 1)]) : _vm._e()])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm._v(" Thank you for your registration. Your demand will be reviewed by our team. You will soon receive an e-mail to finish your subscription. "), _c("br"), _vm._v(" Please consider checking your spam folder if you don't receive our response directly in your mail box. ")]);
}];
render._withStripped = true;
export { render, staticRenderFns };